import {
  getCardTransactionConfigKey,
  TCardTransactionColumnSetting,
} from '@/features/cards/store/models/card-transactions.model';
import { PaymentTruncateCell } from '@/features/cards/components/CardTransactionsTable/PaymentTruncateCell';
interface IPaymentMccCellProps {
  mccCode?: string;
  mccDescription?: string;
  config?: TCardTransactionColumnSetting;
}

export function PaymentMccCell({ mccCode, mccDescription, config }: IPaymentMccCellProps) {
  return (
    <div className="flex flex-col min-w-[100px]">
      {getCardTransactionConfigKey(config, 'mccCode') && (
        <span className="text-secondary typo-body-semibold-small">{mccCode}</span>
      )}
      {mccDescription && getCardTransactionConfigKey(config, 'mccLocal') && (
        <PaymentTruncateCell textString={mccDescription} className="text-tertiary typo-body-regular-small" />
      )}
    </div>
  );
}
